import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [merchant, setMerchant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('merchant_token');
    if (token) {
      authAPI.me()
        .then(res => {
          setUser(res.data.user);
          setMerchant(res.data.merchant);
        })
        .catch(() => {
          localStorage.removeItem('merchant_token');
          localStorage.removeItem('merchant_user');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await authAPI.login({ email, password });
    const { token, user, merchant } = res.data;
    localStorage.setItem('merchant_token', token);
    localStorage.setItem('merchant_user', JSON.stringify(user));
    setUser(user);
    setMerchant(merchant);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('merchant_token');
    localStorage.removeItem('merchant_user');
    setUser(null);
    setMerchant(null);
  };

  const hasPermission = (permission) => {
    if (!user) return false;
    if (user.role === 'owner') return true;
    const rolePermissions = {
      admin: ['payments.view', 'payments.refund', 'payouts.view', 'settings.webhooks', 'analytics.view'],
      accountant: ['payments.view', 'payouts.view', 'payouts.request', 'analytics.view'],
      operator: ['payments.view']
    };
    return rolePermissions[user.role]?.includes(permission) || false;
  };

  return (
    <AuthContext.Provider value={{ user, merchant, loading, login, logout, hasPermission, setUser, setMerchant }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};
